import { Link, Outlet } from "react-router-dom";
import Loginimage from '../assets/images/ezparklogo.png'
import Header from "./Header/Header";
import { Button, Typography, Container, TextField, Switch, InputAdornment, InputLabel, FormControl, OutlinedInput, IconButton } from "@mui/material";
import React from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
const Main = () => {

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  return (
    <>
      <Header />
      <div id="main-app">
        <div className="kpi-dahboard-page">
       
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Main;
